module.exports = __webpack_public_path__ + "img/success.c8892270.png";